import { Box } from "@/components/ui/box";
import { BASE_PATH } from "@/shared/constants/constant";
import { cn } from "@/shared/lib/utils";
import Image from "next/image";
import { ComponentType, SVGProps } from "react";
import ProductIcon from "~/icons/Product.svg";
import ReportIcon from "~/icons/report.svg";
import SendIcon from "~/icons/send.svg";
import DriverIcon from "~/icons/Driver.svg";
import CabinetIcon from "~/icons/pic-driver.svg";
import { Spinner } from "@/components/ui/spinner";

interface StatCardProps {
  title: string;
  value?: number;
  subtitle?: string;
  value2?: number;
  subtitle2?: string;
  type?: "product" | "report" | "send" | "pic" | "cabinet";
  variant?: "default" | "success";
  className?: string;
  srcIcon?: string;
  loading?: boolean;
  onClick: () => void;
}

export default function StatCard({
  title,
  value,
  subtitle,
  value2,
  subtitle2,
  type,
  variant = "default",
  className,
  srcIcon,
  loading,
  onClick,
}: StatCardProps) {
  const ICON_MAP: Record<
    NonNullable<StatCardProps["type"]>,
    ComponentType<SVGProps<SVGSVGElement>>
  > = {
    product: ProductIcon,
    report: ReportIcon,
    send: SendIcon,
    pic: DriverIcon,
    cabinet: CabinetIcon,
  };

  const Icon = type ? ICON_MAP[type] : null;

  return (
    <div
      className={cn(
        "flex h-full flex-col rounded-xl px-6 py-4 shadow-sm",
        variant === "success" ? "bg-green-600 text-white" : "bg-white",
        className
      )}
      onClick={onClick}
    >
      <p
        className={cn(
          `text-lg font-semibold`,
          `${variant === "success" ? "text-white" : "text-[#212121]"}`
        )}
      >
        {title}
      </p>

      {/* bottom content */}
      <div className="mt-3 flex flex-wrap items-center gap-4">
        <Box className="flex items-center gap-4">
          {Icon && (
            <Box
              className={cn(
                "w-10 h-10 flex items-center justify-center p-2 rounded-lg flex-shrink-0",
                variant === "success" ? "bg-white/10" : "bg-[#F7F5F8]"
              )}
            >
              <Icon
                className={cn(
                  "w-5 h-5",
                  variant === "success" ? "text-white" : "text-green-600"
                )}
              />
            </Box>
          )}

          <Box className="flex items-center gap-2">
            {/* <span className="text-3xl font-bold">{value}</span> */}
            {loading ? (
              <Spinner className="h-6 w-6" />
            ) : (
              <span className="text-3xl font-semibold">{value}</span>
            )}
            {subtitle && (
              <span
                className={cn(
                  `text-sm font-normal`,
                  `${
                    variant === "success" ? "text-green-100" : "text-[#6E6E6E]"
                  }`
                )}
              >
                {subtitle}
              </span>
            )}
          </Box>
        </Box>

        <Box className="flex items-center gap-4">
          {value2 && (
            <Box
              className={cn(
                "relative w-10 h-10 flex items-center justify-center p-2 rounded-lg flex-shrink-0",
                variant === "success" ? "bg-white/10" : "bg-[#F7F5F8]"
              )}
            >
              {/* garis miring merah */}
              <span
                className={cn(
                  "absolute top-1/2 h-6 w-[2px] -translate-y-1/2 rotate-[45deg] bg-red-500"
                )}
              />

              <DriverIcon
                className={cn(
                  "w-5 h-5",
                  variant === "success" ? "text-white" : "text-green-600"
                )}
              />
            </Box>
          )}

          {value2 && (
            <Box className="flex items-center gap-2">
              <span className="text-3xl font-semibold">{value2}</span>
              {subtitle2 && (
                <span
                  className={cn(
                    `text-sm font-normal`,
                    `${
                      variant === "success"
                        ? "text-green-100"
                        : "text-[#6E6E6E]"
                    }`
                  )}
                >
                  {subtitle2}
                </span>
              )}
            </Box>
          )}
        </Box>
      </div>
    </div>
  );
}
